var _rect, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPriceMeAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 29,
    height: 29,
    rx: 8.5,
    fill: "white",
    stroke: "#343462",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 21,
    height: 22,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2_207",
    transform: "matrix(0.0111111 0 0 0.0106061 0 0.0227273)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2_207",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAABzUlEQVR4nO2cvU4CQRRGt1LfQUsq2vlC6HgKW82MlqJv6U+FPopZe8wECwo1sLvc2bl7TnIrQjZz+HJhN19oGgAAAAAAAAAAODmr1e2FlJ6k+CalLylt/5j82msI8XE2W5/z0RzBYnF/JcWPf+T+OiGk9/zeY6418STHoyXvyybZB7BbF90k78leH3KtSaPdTu4lWoovpc8xeqTYDiC6LX2O0aPekndT+hyjR4hGtCtEohHtCpFoRLtCJBrRrhCJRrQrRKIR7QqRaES7QiQa0a4Qie7cu9hWPuV6I117F6p8THsjfXsXqnzMeiND9C5U+Zj0RobpXaTKx6A3MkzvIlU+Br2R8odMoxhEC9Hb0ikk0SovjtWh8lLZ0XItmp93IaRPC9HcsMjghiU/xSq9H1V4Qrh7OLno/EAlP1iZruS0mc+vzxoL8qPCKcoOIW2Wy5vLxpKfZK/zvvL9BRnbEOJzXhdmSbZAAwkqfY7RI0Qj2hUi0Yh2hUg0ol0hEo1oV4hEI9oVItGIdoVINKJdIRKNaFeIRFuJjm0VvYvaEX8waEMYoDdi0ruonVnP3ohp76J2Fh17I0V6F7UzO7g34rR3AQAAAAAAAADQjJdvItT9MnUkdcgAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceMeAdd);
export default __webpack_public_path__ + "static/media/price-me-add.61023a8d757f4aff145ca26677e83fa1.svg";
export { ForwardRef as ReactComponent };